import { render, staticRenderFns } from "./ClosingStep.vue?vue&type=template&id=5ca63499&"
import script from "./ClosingStep.vue?vue&type=script&lang=js&"
export * from "./ClosingStep.vue?vue&type=script&lang=js&"
import style0 from "./ClosingStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports